import React, { useState, useEffect } from 'react'
import { skipToken } from '@reduxjs/toolkit/query/react'
import Style from '../styles/pages/MyAnimations.module.scss'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import arrowLeft from '../shared/images/icon-arrow-left.svg'
import { Box, Typography, List, ListItem , Avatar} from '@mui/material'
import arrow from '../shared/images/arrow-down.svg'
import { RootState } from '../store/GlobalStore'
import { useGetUserIncomingAnimationsQuery,
    useGetUserPastAnimationsQuery } from '../services/AnimationsAPI'
    import { SingleAnimation } from '../utils/Interface'
import NotificationContainer from '../components/layout/NotificationContainer'
import { useTranslation } from 'react-i18next';
const MyAnimationPage: React.FC = () => {
    const authState = useSelector((state: RootState) => state.Auth)
    const { t, i18n  } = useTranslation();
     // Ne pas appeler la query si l'utilisateur n'est pas défini
     const userId = authState?.user?.id

     // Définir l'état pour basculer entre "À venir" et "Passées"
    const [activeTab, setActiveTab] = useState<'incoming' | 'past'>('incoming')

     // Requêtes API pour les animations à venir et passées
    const { data: userIncomingAnimationsData, error: userIncomingAnimationsError, isLoading: userIncomingAnimationsLoading, refetch: refetchIncoming } =
    useGetUserIncomingAnimationsQuery(userId ? userId : skipToken)

    const { data: userPastAnimationsData, error: userPastAnimationsError, isLoading: userPastAnimationsLoading, refetch: refetchPast } =
        useGetUserPastAnimationsQuery(userId ? userId : skipToken)

     const navigate = useNavigate()
    const dispatch = useDispatch()

    useEffect(() => {
        if (userId) {
            if (activeTab === 'incoming') {
                refetchIncoming()
            } else {
                refetchPast()
            }
        }
        //console.log("userIncomingAnimationsData ==>" + JSON.stringify(userIncomingAnimationsData))
    }, [authState.user, refetchIncoming, refetchPast, activeTab])

    // Fonction pour obtenir les participants d'une inscription spécifique
  const getParticipantsForUser = (animation: SingleAnimation, id: number) => {
    // Trouver l'inscription de l'utilisateur dans l'animation
    console.log("animation.Inscriptions ====>" + JSON.stringify(animation.Inscriptions))
    const userInscription = animation.Inscriptions.find(
      (inscription) => inscription.user.id === id
    );
    // Retourner le nombre de participants, ou 0 si l'utilisateur n'est pas inscrit
    return userInscription ? userInscription.participants : 0;
  }

    return (
        <div className={Style.MainContainer}>
            <NotificationContainer />
            <div className={Style.TopContainer}>
                <Link to='/mon-compte'>
                    <button className={Style.arrowButton}>
                        <img src={arrowLeft} alt='Arrow Left' />
                    </button>
                </Link>
                <h2>{t('animations')}</h2>
                <p>{t('animations_sub')}</p>
            </div>
            <div>
                {/* Onglets pour basculer entre "À venir" et "Passées" */}
            <div className={Style.Tabs}>
                <button
                    className={`${Style.incomingButton} ${activeTab === 'incoming' ? Style.active : ''}`}
                    onClick={() => setActiveTab('incoming')}
                >
                    {t('future')}
                </button>
                <button
                    className={`${Style.pastButton} ${activeTab === 'past' ? Style.active : ''}`}
                    onClick={() => setActiveTab('past')}
                >
                    {t('past')}
                </button>
            </div>
                <div className={Style.DesktopFormField}>
                    <Box className={Style.AccountBox}>
                    <List>
                            {/* Affichage des animations selon le tab actif */}
                            {activeTab === 'incoming' && (
                                <>
                                    {userIncomingAnimationsLoading && <div>t('loading') + '...'</div>}
                                    {userIncomingAnimationsError && <div>Erreur lors de la récupération des animations à venir</div>}
                                    {userIncomingAnimationsData && userIncomingAnimationsData.length > 0 ? (
                                        userIncomingAnimationsData
                                        .map((animation, index) => (
                                            <ListItem
                                                key={index}
                                                className={Style.AnimationItem}
                                                component={Link}
                                                to={`/animation-details/${animation.id}`}
                                            >
                                                <div className={Style.AnimationContent}>
                                                    <img
                                                        src={String(String(process.env.REACT_APP_BASE_URL) + userIncomingAnimationsData[index].images?.[0]?.url) || 'default-image.png'}
                                                        alt={animation.title}
                                                        className={Style.AnimationImage}
                                                    />
                                                    <div className={Style.AnimationInfo}>
                                                        <div className={Style.Lieu}>Les Settons</div>
                                                        <div>
                                                        <Typography variant="body2" className={Style.strong}>{animation.title}</Typography>
                                                        <Typography variant="body2" className={Style.thin}>
                                                            {new Date(animation.date).toLocaleDateString(i18n.language, {
                                                                day: 'numeric',
                                                                month: 'short',
                                                            })}{' '}
                                                            - {new Date(animation.date).toLocaleTimeString(i18n.language, {
                                                                hour: '2-digit',
                                                                minute: '2-digit',
                                                            })}
                                                        </Typography>
                                                        <Typography variant="body2" className={Style.thin}>
                                                            {getParticipantsForUser(animation,Number(userId))} participants
                                                        </Typography>
                                                        </div>
                                                        <Typography variant="body2" className={Style.strong}>{t('free')}</Typography>
                                                    </div>
                                                </div>
                                                <img src={arrow} alt='arrow' className={Style.ArrowIcon} />
                                            </ListItem>
                                        ))
                                    ) : (
                                        <Typography>{t('no_animation_found')}</Typography>
                                    )}
                                </>
                            )}

                            {activeTab === 'past' && (
                                <>
                                    {userPastAnimationsLoading && <div>{t('loading') + '...'}</div>}
                                    {userPastAnimationsError && <div>Erreur lors de la récupération des animations passées</div>}
                                    {userPastAnimationsData && userPastAnimationsData.length > 0 ? (
                                        userPastAnimationsData.map((animation, index) => (
                                            <ListItem
                                                key={index}
                                                className={Style.AnimationItem}
                                                component={Link}
                                                to={`/animation-details/${animation.id}`}
                                            >
                                                <div className={Style.AnimationContent}>
                                                    <img
                                                        src={String(String(process.env.REACT_APP_BASE_URL) + userPastAnimationsData[index].images?.[0]?.url) || 'default-image.png'}
                                                        alt={animation.title}
                                                        className={Style.AnimationImage}
                                                    />
                                                    <div className={Style.AnimationInfo}>
                                                        <div className={Style.Lieu}>Les Settons</div>
                                                        <div>
                                                        <Typography variant="body2" className={Style.strong}>{animation.title}</Typography>
                                                        <Typography variant="body2" className={Style.thin}>
                                                            {new Date(animation.date).toLocaleDateString('fr-FR', {
                                                                day: 'numeric',
                                                                month: 'short',
                                                            })}{' '}
                                                            - {new Date(animation.date).toLocaleTimeString('fr-FR', {
                                                                hour: '2-digit',
                                                                minute: '2-digit',
                                                            })}
                                                        </Typography>
                                                        <Typography variant="body2" className={Style.thin}>
                                                            {animation?.Inscriptions[0]?.participants} participants
                                                        </Typography>
                                                        </div>
                                                        <Typography variant="body2" className={Style.strong}>Gratuit</Typography>
                                                    </div>
                                                </div>
                                                <img src={arrow} alt='arrow' className={Style.ArrowIcon} />
                                            </ListItem>
                                        ))
                                    ) : (
                                        <Typography>{t('no_animation_found_past')}</Typography>
                                    )}
                                </>
                            )}
                        </List>
                    </Box>
                </div>
            </div>
        </div>
    )
}

export default MyAnimationPage
